export default "__VITE_ASSET__aYfOwwuL__"